const TUTELLUS_CDN = "https://d33j98c122wnb5.cloudfront.net/tutellus"

export const TUTELLUS_LOGO = `${TUTELLUS_CDN}/logos/tutellus-logo.svg`

export const TUTELLUS_DESKTOP_LOGO_DARK = `${TUTELLUS_CDN}/logos/tutellus-logo-dark.svg`

export const TUTELLUS_DESKTOP_LOGO_LIGHT = `${TUTELLUS_CDN}/logos/tutellus-logo.svg`

export const TUTELLUS_TOKEN_LOGO = `${TUTELLUS_CDN}/logos/tutellus-isotipo.png`

export const TUTELLUS_ISOTIPO = `${TUTELLUS_CDN}/logos/tutellus-isotipo.svg`

export const HW_LOGO =
  "https://cdn.prod.website-files.com/64bfe0b7cf5ceb8900f47cfc/64c21b6ef28c42e30c354435_human-wallet.icon-32.png"

export const IPHONE_MOCKUP_1 =
  "https://cdn.prod.website-files.com/6437da1ecf38d26c463890a8/684fe8784fea75a947b3addd_hw-iphone.png"
